<template>
    <div>
        <loading :active.sync="loading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
        <b-row>
            <b-col cols="12">
                <card>
                    <b-row >
                        <b-col lg="6">
                            <base-input :label="language_terms['TYPE']">
                                <el-select v-model="priceSetup.type" :placeholder="language_terms['action']" >
                                    <el-option
                                    v-for="item in activeOptions"
                                    :key="item.value"
                                    :label="language_terms[item.label]"
                                    :value="item.value"
                                    >
                                    </el-option>
                                </el-select>
                            </base-input>
                        </b-col>
                        <b-col lg="6" v-if="priceSetup.type == 'product_category'">
                            <label class="form-control-label">{{language_terms['PRODUCT_CATRGORY']}}</label>
                            <multiselect
                                :custom-label="categoryNameWithCode"
                                v-model="priceSetup.category"
                                id="ajax"
                                label="name"
                                track-by="id"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :options="productCategories"
                                :multiple="false"
                                :searchable="true"
                                :loading="loading"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="50"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                                @search-change="asyncProductCategories"
                                >
                            </multiselect>
                        </b-col>
                        <b-col lg="6" v-if="priceSetup.type == 'product'">
                            <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                            <multiselect
                                :custom-label="productNameWithCode"
                                v-model="priceSetup.product"
                                id="ajax"
                                label="name"
                                track-by="id"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :options="products"
                                :multiple="false"
                                :searchable="true"
                                :loading="loading"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="50"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                                @search-change="asyncFindProducts"
                                >
                            </multiselect>
                        </b-col>
                    </b-row>
                    <b-row class="mb-4" v-if="module == 'salechannel'">
                       <b-col lg="12">
                            <label class="form-control-label">{{language_terms["CUSTOMER"]}}</label>
                            <multiselect
                                v-model="priceSetup.customer"
                                :custom-label="customerNameWithCode"
                                id="ajax"
                                label="name"
                                track-by="id"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :options="customers"
                                :multiple="false"
                                :searchable="true"
                                :loading="loading"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="50"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                                @search-change="asyncFindCustomer"
                            >
                            </multiselect>
                       </b-col> 
                    </b-row>
                    <b-row>
                        <b-col lg="6">
                            <base-input :label="language_terms['DATE_FROM']">
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="priceSetup.date_from">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <b-col lg="6" >
                            <base-input :label="language_terms['DATE_TO']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="priceSetup.date_to">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <b-col lg="3" v-if="priceSetup.type == 'product'">
                            <base-input :label="language_terms['BASE_DISCOUNT_UNIT_PRICE']" v-model="priceSetup.base_unit_price" type="number" :min="0"></base-input>
                        </b-col>
                        <b-col lg="3" v-if="priceSetup.type == 'product'">
                            <base-input :label="language_terms['BASE_DISCOUNT_MOQ_PRICE']" v-model="priceSetup.moq_unit_price" type="number" :min="0"></base-input>
                        </b-col>
                        <b-col :lg="priceSetup.type == 'product_category' ? 6: 3">
                            <base-input :label="language_terms['BASE_DISCOUNT_PERCENT']" v-model="priceSetup.base_listprice_discount_percentage" type="number" :min="0">
                            </base-input>
                        </b-col>
                        <b-col :lg="priceSetup.type == 'product_category' ? 5: 2">
                            <base-input :label="language_terms['MOQ_DISCOUNT_PERCENT']" v-model="priceSetup.moq_listprice_discount_percentage" type="number" :min="0">
                            </base-input>
                        </b-col>
                        <b-col lg="1" class='mt-4'>
                            <base-button  type="primary" class='mt-2' @click.native="addPrice">
                                <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                            </base-button>
                        </b-col>
                    </b-row>
                </card>
                <card v-if="priceItems.length > 0">
                    <b-row>
                        <b-col lg="12">
                            <b-table-simple striped hover responsive>
                                <b-thead head-variant="light">
                                    <b-th>{{language_terms['TYPE']}}</b-th>
                                    <b-th>{{language_terms['CODE']}}</b-th>
                                    <b-th>{{language_terms['NAME']}}</b-th>
                                    <b-th>{{language_terms['CUSTOMER']}}</b-th>
                                    <b-th>{{language_terms['DATE_FROM']}}</b-th>
                                    <b-th>{{language_terms['DATE_TO']}}</b-th>
                                    <b-th>{{language_terms['BASE_DISCOUNT_UNIT_PRICE']}}</b-th>
                                    <b-th>{{language_terms['BASE_DISCOUNT_MOQ_PRICE']}}</b-th>
                                    <b-th>{{language_terms['BASE_DISCOUNT_PERCENT']}}</b-th>
                                    <b-th>{{language_terms['MOQ_DISCOUNT_PERCENT']}}</b-th>
                                    <b-th></b-th>
                                </b-thead>
                                <b-tbody>
                                    <tr v-for="(item, j) in priceItems" :key="j">
                                        <td>{{item.type ? language_terms[item.type.toUpperCase()] : item.type}}</td>
                                        <td>{{item.target_code}}</td>
                                        <td>{{item.target_name}}</td>
                                        <td>{{item.contact_name ? (item.contact_name + " (" + item.contact_code + ")") : '-'}}</td>
                                        <td>{{displayDate(item.date_from)}}</td>
                                        <td>{{displayDate(item.date_to)}}</td>
                                        <td>{{item.base_unit_price}}</td>
                                        <td>{{item.moq_unit_price}}</td>
                                        <td>{{item.base_listprice_discount_percentage}}</td>
                                        <td>{{item.moq_listprice_discount_percentage}}</td>
                                        <td>
                                            <base-button type="warning" @click.native="handleDeletePrice(item)" size="sm">
                                                <i class="fa fa-trash"></i>
                                            </base-button>
                                        </td>
                                    </tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>
                    </b-row>
        
                </card>
            </b-col>
        </b-row>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from "vuex";
import {Table,TableColumn,Button,Select, Option} from 'element-ui'
import Multiselect from 'vue-multiselect'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import BaseButton from '../../components/BaseButton.vue';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default 
{
    props:
    {
        module:
        {
            type: String,
            required:true,
            default:null
        },
        customer_id:
        {
            default:-1,
            required:false,
        },
        salechannel_id:{
            default:-1,
            required:false,
        },
        code:{
            default:null,
            required:true,
        },
        customized_prices:{
            type: Array,
            default: function () { return [] },
            required:true,
        }
    },
    data(){
        return{
            fields: ['type', 'code', 'name','date_from','date_to','default_discount','moq_discount','action'],
            priceItems: [],
            loading:false,
            activeOptions:[
            {
                value: "product_category",
                label: "PRODUCT_CATEGORY",
            },
            {
                value: "product",
                label: "PRODUCT",
            },

            ],
            priceSetup:
            {
                base_unit_price:"",
                moq_unit_price:"",
                base_listprice_discount_percentage:"",
                moq_listprice_discount_percentage:"",
                date_from:"",
                date_to:"",
                category:{},
                product:{},
                type:"product_category",
            },
            products:[],
            productCategories:[],
            customers:[]
            }
    },
    computed:{
         ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            is_special_price_created: state => state.salechannels.is_special_price_created,
            is_deleted:state => state.salechannels.is_deleted
         })
    },
     components: {
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        Multiselect,
        BaseButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        Loading

  },
  watch:{
      customized_prices:{
          deep: true,
           handler(){
                this.priceItems = this.customized_prices
            }
      }
  },
mounted()
  {
    this.priceItems = this.customized_prices
  },
  methods:{
        displayDate(date)
        {
            let d = '-';
            
            if(date)
                d = moment(date).format("DD/MM/YYYY");

            return d;
        },
        async asyncFindCustomer(query) 
        {
            this.isLoading = true;
            let pv = { value: query, salechannel_id: this.salechannel_id };
            await axios
                .post(apiRoutes["CUSTOMER_LOOKUP_FOR_SALECHANNEL"], pv, authHeader())
                .then((response) => {
                if (response.data.code == 1) {
                    this.customers = response.data.data;
                } else {
                    this.customers = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                    Vue.notify({
                    group: "notify",
                    type: "error",
                    text: error.response.data.msg,
                    max: 5,
                    duration: 5000,
                    speed: 300,
                    });
                } else {
                    console.log("Problem submitting New Post", error);
                }
                });
        },
        customerNameWithCode ({ name, code }) {
            if(name || code)
                return `${name} (${code})`
        },
        async handleDeletePrice(item){

            //this.priceItems.splice(index, 1)  
            if(item.id)
            {
                await this.$store.dispatch("salechannels/deletePrice", {id:item.id})
                if(this.is_deleted)
                {
                    this.loading = true
                    if(this.module == 'salechannel')
                        await this.$store.dispatch("salechannels/fetch", {code:this.code});
                    else
                        await this.$store.dispatch("customers/fetch", {code:this.code});                    
                    this.loading = false

                }
            }
        },
        categoryNameWithCode ({ name, code }) 
        {
            if(name || code)
                return `${name} (${code})`
        },
        productNameWithCode ({ name, code }) 
        {
            if(name || code)
                return `${name} (${code})`
        },
        async asyncFindProducts(query) 
        {
            this.isLoading = true;
            let pv = { value: query };
            await axios
                .post(apiRoutes["PRODUCT_LOOKUP"], pv, authHeader())
                .then((response) => {
                if (response.data.code == 1) {
                    this.products = response.data.data;
                } else {
                    this.products = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({
                            group: "notify",
                            type: "error",
                            text: error.response.data.msg,
                            max: 5,
                            duration: 5000,
                            speed: 300,
                        });
                    } 
                    else 
                    {
                        console.log("Problem submitting New Post", error);
                    }
                });
        },
        async asyncProductCategories(query) 
        {
            this.isLoading = true;
            let pv = { value: query };
            await axios
                .post(apiRoutes["PRODUCT_CATEGORIES_LOOKUP"], pv, authHeader())
                .then((response) => {
                if (response.data.code == 1) {
                    console.log(response.data.data)
                    this.productCategories = response.data.data;
                } else {
                    this.productCategories = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({
                            group: "notify",
                            type: "error",
                            text: error.response.data.msg,
                            max: 5,
                            duration: 5000,
                            speed: 300,
                        });
                    } 
                    else 
                    {
                        console.log("Problem submitting New Post", error);
                    }
                });
        },
      async addPrice()
      {
          //SALE_CHANNEL_CREATE_SPECIAL_PRICE
          this.priceSetup.salechannel_id = this.salechannel_id
            if(this.priceSetup.type == 'product')
                this.priceSetup.target_id = this.priceSetup.product.id
            else if(this.priceSetup.type == 'product_category')
                this.priceSetup.target_id = this.priceSetup.category.id

            if(this.module == 'salechannel')
            {
                if(this.priceSetup.customer)
                    this.priceSetup.contact_id = this.priceSetup.customer.id
            }
            else 
            {
                this.priceSetup.contact_id = this.customer_id
            }


            if(this.priceSetup.salechannel_id  && this.priceSetup.target_id)
            {
                await this.$store.dispatch("salechannels/createSpecialPrice", this.priceSetup)
                if(this.is_special_price_created)
                {
                    this.loading = true
                    if(this.module == 'salechannel')
                        await this.$store.dispatch("salechannels/fetch", {code:this.code});
                    else
                        await this.$store.dispatch("customers/fetch", {code:this.code});
                    this.loading = false

                    this.priceSetup = {
                        base_listprice_discount_percentage:"",
                        moq_listprice_discount_percentage:"",
                        date_from:"",
                        date_to:"",
                        category:{},
                        product:{},
                        type:"product_category"
                    }
                }
            }
      }
  }

}
</script>

<style>

</style>